import PageInFlowWithSidebarLayout, {
  PageInFlowWithSidebarLayoutProps,
} from 'components/common/general/layouts/PageInFlowWithSidebarLayout';
import React from 'react';
import EnrollmentFlowPage from 'store/flows/enrollment/enrollmentFlowPage';
import { observer } from 'mobx-react-lite';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import EnrollmentSidebar from './EnrollmentSidebar';

interface EnrollmentFlowLayoutProps extends Omit<PageInFlowWithSidebarLayoutProps, 'sidebar' | 'moreInfoBlob'> {
  pageStore: EnrollmentFlowPage;
  isPageLoading?: boolean;
}

const EnrollmentFlowLayout: React.FC<EnrollmentFlowLayoutProps> = observer(
  ({ pageStore, pageId, isPageLoading, ...rest }) => {
    const blobInput = pageStore.groupInfoDelegate.moreInfoBlobInput;

    return (
      <PageInFlowWithSidebarLayout
        {...rest}
        moreInfoBlob={blobInput ? buildGroupContextMoreInfoBlobProps(blobInput) : undefined}
        pageId={pageId}
        sidebar={<EnrollmentSidebar sidebarDelegate={pageStore.sidebarDelegate} />}
        isInitialLoading={isPageLoading}
        isInfoSectionLoading={pageStore.groupInfoDelegate.isFlowDataLoading}
      />
    );
  },
);

export default EnrollmentFlowLayout;
